import Vue from 'vue'
import VueRouter from 'vue-router'



Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'Dashboard',
    //     component: Dashboard,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/',
        name: 'Home',
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/LoginReportes.vue"),
    },
    // {
    //     path: '/ganadores',
    //     name: 'Ganadores',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Ganadores.vue')
    // },
    {
        path: "/administrador",
        name: "Administrador",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/LoginReportes.vue"),
    },
    {
        path: "/administrador/dashboard",
        name: "Informe",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/ReportesInforme.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/administrador/usuarios',
        name: 'InformeDescarga',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesUsuarios.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    },



]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        return { x: 0, y: 0 }
    },
    base: process.env.BASE_URL,
    routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {

    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const requiresUserAuth = to.matched.some((x) => x.meta.requiresUserAuth);
    const requiresAuthAdmin = to.matched.some((x) => x.meta.requiresAuthAdmin);

    let user;

    if (requiresAuth) {
        user = localStorage.getItem("user_lavaygana123_2024");
        user = JSON.parse(user);
        console.log(user);
    } else if (requiresAuthAdmin) {
        user = localStorage.getItem("user_lavaygana123_2024_lector");
        user = JSON.parse(user);
        console.log(user);
    } else if (requiresUserAuth) {
        user = localStorage.getItem("user_lavaygana123_2024");
        user = JSON.parse(user);
        console.log({ userauth: user });
    }

    if (requiresAuth === true && (user == null || user == undefined)) {
        next("/administrador");
    } else {
        next()
    }

})

export default router